type Params = Record<string, string | number | null | undefined>;

const query = (params: Params): string => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, String(value));
    }
  });
  const text = search.toString();
  return text ? `?${text}` : "";
};

// URL of a public player endpoint, e.g. playerApiUrl("TrEz", "pk-insights").
// With no `path` it's the base player stats endpoint.
export const playerApiUrl = (
  player: string,
  path: string,
  params: Params = {}
): string =>
  `${process.env.REACT_APP_API}public/player/${encodeURIComponent(player)}${
    path ? `/${path}` : ""
  }${query(params)}`;
